import {a,b,c} from './a.js'
import {d,e} from './b.js'
let  shiliu = [a,b,c,d,e].join('')

const uint8Array = Uint8Array.from(shiliu .match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
const decoder = new TextDecoder();
const str = decoder.decode(uint8Array);
export default str;